<template>
  <div class="summary-sim">
    <h2 class="h3"><slot name="headline"></slot></h2>
    <ul class="list-unstyled">
        <li>
          <div class="row">
            <div class="label">
              <slot name="lblSimType"></slot>
            </div>
            <div>
              <slot :name="'txtSimType' + simData.simType"></slot>
            </div>
          </div>
        </li>
        <li>
          <div v-if="simData.simType === 'E_SIM' && simData.eID" class="row">
            <div class="label">
              <slot name="lblEID"></slot>
            </div>
            <div>{{ simData.eID }}</div>
          </div>
        </li>
        <li v-if="identData.identType">
          <div class="row">
            <div class="label">
              <slot name="lblNationalityIdent"></slot>
            </div>
            <div>{{ identData.nationality.name }}</div>
          </div>
        </li>
        <li v-if="identData.identType">
          <div class="row">
            <div class="label">
              <slot name="lblIdentCardIdent"></slot>
            </div>
            <div>{{ identData.identCard.name }}</div>
          </div>
        </li>
        <li v-if="identData.identType">
          <div class="row">
            <div class="label">
              <slot name="lblIdentTypeIdent"></slot>
            </div>
            <div>
              <slot :name="'txtIdentType' + identData.identType + 'Ident'"></slot>
            </div>
          </div>
        </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'Sim',
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  computed: {
    simData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_simData/simData'] || null
    },
    identData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_identData/identData'] || null
    }
  }
}
</script>
